
import { sync } from 'vuex-pathify'

export default {
  props: {
    slides: {
      type: Array,
      default: null
    }
  },
  vessel: {
    boxParent: {
      paddingBottom: 'lg'
    },
    box: {
      backgroundColor: 'white',
      width: '5/6',
      padding: 'sm',
      textAlign: 'center',
      maxWidth: 'full',
      md: {
        width: '4xl',
        padding: 'md'
      }
    },
    title: {
      marginBottom: 'xs',
      fontSize: 'lg',
      fontWeight: 'semibold'
    },
    text: {
      lineHeight: 'md'
    },
    boxTitle: {
      $extend: 'title',
      marginBottom: '2xs',
      fontSize: 'md',
      md: {
        fontSize: 'lg',
      }
    },
    boxText: {
      $extend: 'text',
      fontSize: 'sm',
      md: {
        fontSize: 'md',
      }
    }
  },
  computed: {
    selectedSolution: sync('registerForm@solution')
  },
  methods: {
    onClick({ solution }) {
      this.selectedSolution = solution
    },
    dotProps(active) {
      if (active) {
        return {
          name: 'triangle',
          color: 'primary'
        }
      } else {
        return {
          name: 'circle',
          color: 'grey',
          fontSize: 'xs'
        }
      }
    }
  }
}
